/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} User_Detail_Show_DeckInputs */



/**
* | output |
* | --- |
* | "Show the decklist: {name}" |
*
* @param {User_Detail_Show_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_show_deck = /** @type {((inputs: User_Detail_Show_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Show_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Afficher la liste : ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ver la lista de mazo: ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Ver a lista de deck: ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Mostra la decklist: ${i?.name}`)
	return /** @type {LocalizedString} */ (`Show the decklist: ${i?.name}`)
});